import React, { useState, useCallback, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { ScreenNameList } from "@lib/utilities/Constants";
import { Logger } from "@lib/utilities/HelperFunctions";
import { clearSessionAndLogout } from "@lib/utilities/AuthHelper";
import { POLICY_ACTION_ROUTE } from "../../../src/navigation/NavigationConstants";
import { useAppDispatch, useAppSelector } from "@lib";
import {
  setCurrentPolicyNumber,
  toogleLoading,
} from "@lib";
import { PolicyType } from "@lib";
import { introspectionAPI } from "@lib";

import CheckSession from "@lib/utilities/CheckSession";
import { useFocusEffect } from "@react-navigation/native";
import { messages } from "../../../src/resources/strings";
import { resetPolicyDetail } from "@lib";
import { policyListingHandler } from "@lib";
import { BackHandler } from "react-native";

interface UsePolicyListingProps {
  navigation: any;
}

interface UsePolicyListingReturn {
  errorData: {
    message: string;
    screenName: string;
    showAsAlert: boolean;
  };
  onEndTimer: () => void;
  onReloadPress: () => void;
  isLoading: boolean;
  handlePolicySelection: (policy: PolicyType) => Promise<void>;
  showAlerts: boolean;
}

interface UsePolicyListingProps {
  navigation: any;
}
export const usePolicyListing = ({
  navigation,
}: UsePolicyListingProps): UsePolicyListingReturn => {
  // State
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = useState<string>(
    messages.error.noError
  );
  const setLoading = (status: boolean) => {
    dispatch(toogleLoading(status));
  };
  const { fetchAllPolicies } = policyListingHandler(setErrorMessage);
  const { isLoading } = useAppSelector((state) => state.policyReducer);
  const [showAlerts, setShowAlerts] = useState(false);

  // Utility: Introspection check
  const handleIntrospectionCheck = async (): Promise<boolean> => {
    try {
      const response = await introspectionAPI();
      if (!response?.response) {
        setErrorMessage(messages.error.sessionExpired);
        setLoading(false);
        return false;
      }
      return true;
    } catch (error) {
      setLoading(false);
      Logger(["Introspection API Error:", error]);
      return false;
    }
  };

  // Policy selection
  const handlePolicySelection = async (policy: PolicyType) => {
    dispatch(setCurrentPolicyNumber(policy.policyNumber));
    navigation.navigate(POLICY_ACTION_ROUTE);
  };

  // Initialization
  const initializePolicyListing = async () => {
    setLoading(true);
    const isIntrospectionValid = await handleIntrospectionCheck();
    if (isIntrospectionValid) {
      await fetchAllPolicies();
    }
  };

  // Initial check
  const checkSessionBeforeApi = async () => {
    const session = await CheckSession();
    if (session) {
      initializePolicyListing();
    } else {
      clearSessionAndLogout(navigation, logout);
    }
  };

  // Lifecycle
  useFocusEffect(
    React.useCallback(() => {
      dispatch(resetPolicyDetail());
      checkSessionBeforeApi();
      const onBackPress = () => {
        BackHandler.exitApp();
        return true;
      };
      const sub = BackHandler.addEventListener(
        "hardwareBackPress",
        onBackPress
      );
      return () => sub.remove();
    }, [])
  );

  // Error data and handlers
  const errorData = {
    message: errorMessage,
    screenName: ScreenNameList.choosePolicy,
    showAsAlert: showAlerts,
  };
  const onEndTimer = () => {
    setShowAlerts(true);
    setErrorMessage(messages.error.noError);
  };
  const onReloadPress = () => {
    setShowAlerts(false);
    initializePolicyListing();
  };

  return {
    isLoading,
    handlePolicySelection,
    showAlerts,
    errorData,
    onEndTimer,
    onReloadPress,
  };
};
